import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeModule } from './modules/home-module';
import { AuthGuard } from './core/auth-guard';
import { LoginAggreementComponent } from './components/login-aggreement/login-aggreement.component';

const routes: Routes = [
  //{ path: '', redirectTo: 'auth', pathMatch: 'full' },
  { path: 'auth', loadChildren: () => import('./modules/auth-module').then(m => m.AuthModule) },  
  { path: 'error', loadChildren: () => import('./modules/dialog-box.module').then(m => m.DialogBoxModule) },
   { path: 'view', loadChildren: () => import('./modules/view-module').then(m => m.ViewModule) }, 
   { path: 'edit', loadChildren: () => import('./modules/create-module').then(m => m.CreatModule) ,canActivate:[AuthGuard] },
  { path: 'home', loadChildren: () => HomeModule },
  { path: 'create', loadChildren: () => import('./modules/create-module').then(m => m.CreatModule) ,canActivate:[AuthGuard] },
  { path: 'forms', loadChildren: () => import('./modules/formly-module').then(m => m.FormlyFormModule) ,canActivate:[AuthGuard] },
  {
    path: 'transaction',
        loadChildren: () =>
          import('./modules/transaction.module').then(
            (m) => m.TransactionModule
          ),
      },
      { path: 'login-agreement', component: LoginAggreementComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
